import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { DialogType } from "./medi-dialog/medi-dialog.component";
import { OroService } from "./oroservice";

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard  {
    constructor(public oroservice: OroService) {
    }

    canDeactivate(component: CanComponentDeactivate): boolean | Observable<boolean> {
        // if there are no pending changes, just allow deactivation; else confirm first
        return component.canDeactivate() ?
          true :
          //confirm('Sie haben nicht gespeicherte Änderungen, möchten Sie die Ansicht ohne zu speichern verlassen?');
          this.oroservice.openDialog("500px", "Achtung", "WarningChange", "Ja", "Startseite.Abbrechen", DialogType.Warning);
      }
}